import useCustomEventListener from "./useCustomEventListener";

const DISCOUNT_REMOVED_EVENT = "discount-removed";

const useRemoveDiscountListener = (callback) => {
    useCustomEventListener(DISCOUNT_REMOVED_EVENT, callback);
};

export default useRemoveDiscountListener;
